var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 210.24,
    height: 334.101,
    viewBox: "0 0 210.24 334.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_662",
    "data-name": "Groupe 662",
    transform: "translate(414.51 -194.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_660",
    "data-name": "Groupe 660",
    transform: "translate(-340.724 517.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1182",
    "data-name": "Trac\\xE9 1182",
    d: "M-279.63,566.976h.931v10.537h-.931v.155h3.564v-.155H-277V566.976h.93v-.155h-3.564Z",
    transform: "translate(323.636 -566.511)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_659",
    "data-name": "Groupe 659",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1183",
    "data-name": "Trac\\xE9 1183",
    d: "M-326.739,566.821H-330.3v.155h.93v10.537h-.93v.155h3.564v-.155h-.929V573.33h.929c2.635,0,4.184-1.55,4.184-3.255S-324.1,566.821-326.739,566.821Zm2.325,5.811a4.986,4.986,0,0,1-2.325.543h-.929v-6.2h.929a4.992,4.992,0,0,1,2.325.542Z",
    transform: "translate(330.303 -566.511)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1184",
    "data-name": "Trac\\xE9 1184",
    d: "M-310.481,566.821h-.309l-3.642,10.692h-1.239v.155h2.635v-.155h-1.24l.945-2.789h3.781l1.007,2.789h-.93v.155h3.719v-.155h-.929Zm-2.789,7.747,1.781-5.268,1.86,5.268Z",
    transform: "translate(328.378 -566.511)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1185",
    "data-name": "Trac\\xE9 1185",
    d: "M-289.654,574.724c0-2.464-3.038-2.7-3.239-2.711.294-.016,3.239-.341,3.239-2.557,0-1.394-1.24-2.634-4.185-2.634h-3.1v.155h.931v10.537h-.931v.155h3.565v-.155h-.93V572.09h.62a5.639,5.639,0,0,1,2.324.465v4.959h-.929v.155h3.564v-.155h-.929Zm-4.185-2.789h-.465v-4.958h.465a6.593,6.593,0,0,1,2.325.387v4.184A6.607,6.607,0,0,1-293.839,571.934Z",
    transform: "translate(325.913 -566.511)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1186",
    "data-name": "Trac\\xE9 1186",
    d: "M-266.127,568.479a2.127,2.127,0,0,1,2.325-1.86,3.373,3.373,0,0,1,2.247.853,1.583,1.583,0,0,0-.387-.077,1.059,1.059,0,0,0-1.085,1.085,1.059,1.059,0,0,0,1.085,1.085,1.059,1.059,0,0,0,1.085-1.085c0-.775-1.24-2.015-2.944-2.015a3.17,3.17,0,0,0-3.409,2.944c0,3.875,5.578,3.255,5.578,6.354,0,1.084-.929,2.014-2.478,2.014a4.481,4.481,0,0,1-3.565-2.154v.216a4.484,4.484,0,0,0,3.565,2.092c2.169,0,3.564-1.395,3.564-3.1C-260.548,570.958-266.127,571.577-266.127,568.479Z",
    transform: "translate(322.063 -566.464)",
    fill: "#373738"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1187",
    "data-name": "Trac\\xE9 1187",
    d: "M-406.295,491.425H-409.5v-30.9h3.208l8.643,16.3,8.97-16.3h3.339l-12.08,22.131-8.872-16.107v24.881",
    transform: "translate(-0.001 -34.942)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1188",
    "data-name": "Trac\\xE9 1188",
    d: "M-380.808,460.52h3.274v30.9h-3.274V466.544l-13.357,24.881h-3.274Z",
    transform: "translate(-1.588 -34.942)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1189",
    "data-name": "Trac\\xE9 1189",
    d: "M-346.668,460.52l-13.946,30.9h27.827Zm-.032,7.6,9.068,20.1h-18.006Z",
    transform: "translate(-6.433 -34.942)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 3.274,
    height: 30.905,
    transform: "translate(-327.276 425.578)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1190",
    "data-name": "Trac\\xE9 1190",
    d: "M-240.868,460.52a15.452,15.452,0,0,0-15.453,15.452,15.453,15.453,0,0,0,15.453,15.453,15.452,15.452,0,0,0,15.452-15.453A15.452,15.452,0,0,0-240.868,460.52Zm0,27.631a12.179,12.179,0,0,1-12.179-12.179,12.178,12.178,0,0,1,12.179-12.178,12.178,12.178,0,0,1,12.179,12.178A12.179,12.179,0,0,1-240.868,488.151Z",
    transform: "translate(-20.155 -34.942)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1191",
    "data-name": "Trac\\xE9 1191",
    d: "M-206.6,460.52V485.2h9.232v-2.946h-6.351V466.216l17.744,25.208h3.4v-30.9h-3.536v25.208L-203.2,460.52Z",
    transform: "translate(-26.697 -34.942)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 12.441,
    height: 3.274,
    transform: "translate(-233.3 453.209)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1192",
    "data-name": "Trac\\xE9 1192",
    d: "M-278.228,475.072c4.622,1.324,8.039,4.257,8.039,7.949,0,4.633-5.3,8.39-11.842,8.39s-11.375-3.786-11.842-8.39a2.813,2.813,0,0,1,.023-.527h0l3.05-1.056a8.947,8.947,0,0,0,.979,3.473c1.119,2.256,4.28,3.85,7.964,3.85,4.656,0,8.432-2.57,8.432-5.739,0-2.86-3.125-4.881-7.092-5.668-6.26-1.242-7.159-1.709-7.159-1.709-3.249-1.4-5.439-4.049-5.439-7.084,0-4.5,4.814-8.147,10.752-8.147,5.843,0,10.6,3.53,10.749,7.93l-3.644,1.028a3.684,3.684,0,0,0,.148-1.029c0-2.847-3.306-5.154-7.384-5.154s-7.383,2.307-7.383,5.154c0,2.188,1.951,4.056,4.705,4.805C-285.173,473.147-282.4,473.877-278.228,475.072Z",
    transform: "translate(-15.214 -34.928)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1193",
    "data-name": "Trac\\xE9 1193",
    d: "M-322.181,546.781h-3.208v-30.9h3.208l8.643,16.3,8.97-16.3h3.339l-12.08,22.131-8.872-16.107v24.881",
    transform: "translate(-11.068 -42.225)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1194",
    "data-name": "Trac\\xE9 1194",
    d: "M-296.695,515.876h3.274v30.9h-3.274V521.9l-13.357,24.881h-3.274Z",
    transform: "translate(-12.655 -42.225)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1195",
    "data-name": "Trac\\xE9 1195",
    d: "M-356.712,515.876l-13.946,30.9h27.827Zm-.032,7.6,9.068,20.1h-18.006Z",
    transform: "translate(-5.112 -42.225)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 3.274,
    height: 30.905,
    transform: "translate(-251.823 473.651)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1196",
    "data-name": "Trac\\xE9 1196",
    d: "M-206.6,515.876V540.56h9.232v-2.946h-6.351V521.572l17.744,25.208h3.4v-30.9h-3.536v25.208L-203.2,515.876Z",
    transform: "translate(-26.697 -42.225)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 12.441,
    height: 3.274,
    transform: "translate(-233.3 501.282)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1197",
    "data-name": "Trac\\xE9 1197",
    d: "M-254.087,529.588a8.074,8.074,0,0,0,2.261-5.614,8.1,8.1,0,0,0-8.1-8.1h-13.124v3.393h13.411a4.7,4.7,0,0,1,4.705,4.705,4.705,4.705,0,0,1-4.705,4.705h-13.411v18.1h14.593a9.152,9.152,0,0,0,9.152-9.152A9.134,9.134,0,0,0-254.087,529.588Zm-4.493,13.919h-11.593V531.751h11.593a5.878,5.878,0,0,1,5.878,5.878A5.878,5.878,0,0,1-258.58,543.507Z",
    transform: "translate(-17.955 -42.225)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1198",
    "data-name": "Trac\\xE9 1198",
    d: "M-393.859,530.428c4.622,1.324,8.039,4.257,8.039,7.948,0,4.634-5.3,8.391-11.842,8.391s-11.375-3.786-11.842-8.391a2.807,2.807,0,0,1,.023-.526h0l3.05-1.056a8.947,8.947,0,0,0,.979,3.473c1.119,2.256,4.281,3.85,7.964,3.85,4.657,0,8.432-2.57,8.432-5.74,0-2.859-3.125-4.88-7.092-5.667-6.26-1.242-7.159-1.709-7.159-1.709-3.249-1.4-5.439-4.049-5.439-7.084,0-4.5,4.814-8.147,10.752-8.147,5.843,0,10.6,3.53,10.749,7.93l-3.644,1.028a3.684,3.684,0,0,0,.147-1.029c0-2.847-3.305-5.154-7.383-5.154s-7.383,2.307-7.383,5.154c0,2.188,1.951,4.056,4.705,4.8C-400.8,528.5-398.032,529.233-393.859,530.428Z",
    transform: "translate(0 -42.211)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 2.875,
    height: 9.411,
    transform: "translate(-291.003 477.044)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_661",
    "data-name": "Groupe 661",
    transform: "translate(-409.51 194.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1199",
    "data-name": "Trac\\xE9 1199",
    d: "M-283.441,326.1h33.06a57.7,57.7,0,0,0,57.7-57.7,57.7,57.7,0,0,0-57.7-57.7h-33.06",
    transform: "translate(392.923 -197.021)",
    fill: "none",
    stroke: "#373738",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1200",
    "data-name": "Trac\\xE9 1200",
    d: "M-318.751,210.7h-33.061a57.7,57.7,0,0,0-57.7,57.7,57.7,57.7,0,0,0,57.7,57.7h33.061",
    transform: "translate(409.51 -197.021)",
    fill: "none",
    stroke: "#373738",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1201",
    "data-name": "Trac\\xE9 1201",
    d: "M-283.441,393.036h33.06a57.7,57.7,0,0,0,57.7-57.7,57.7,57.7,0,0,0-57.7-57.7h-33.06",
    transform: "translate(392.923 -205.828)",
    fill: "none",
    stroke: "#373738",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1202",
    "data-name": "Trac\\xE9 1202",
    d: "M-318.751,277.64h-33.061a57.7,57.7,0,0,0-57.7,57.7,57.7,57.7,0,0,0,57.7,57.7h33.061",
    transform: "translate(409.51 -205.828)",
    fill: "none",
    stroke: "#373738",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_83",
    "data-name": "Ligne 83",
    y1: 94.142,
    transform: "translate(90.759)",
    fill: "none",
    stroke: "#373738",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_84",
    "data-name": "Ligne 84",
    y2: 94.142,
    transform: "translate(109.482)",
    fill: "none",
    stroke: "#373738",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_85",
    "data-name": "Ligne 85",
    y1: 94.142,
    transform: "translate(90.759 106.098)",
    fill: "none",
    stroke: "#373738",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_86",
    "data-name": "Ligne 86",
    y2: 94.142,
    transform: "translate(109.482 106.098)",
    fill: "none",
    stroke: "#373738",
    strokeWidth: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.89b94556751d00fca18c0c2a1a795c6d.svg";
export { ForwardRef as ReactComponent };